import { Provider } from "react-redux";
import { ReactNode } from "react";
import store, { persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import ThemeRegistry from "./theme/registry";

type AppProvidersProps = { children: ReactNode };

function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeRegistry>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {children}
        </PersistGate>
      </Provider>
    </ThemeRegistry>
  );
}

export { AppProviders };
